import { memo, useMemo } from 'react'
import { useOrganizationsContext } from '../organizations/OrganizationsProvider'

type OrgCellProps = {
  orgId: string
}

function OrgCell({ orgId }: OrgCellProps) {
  const { organizations } = useOrganizationsContext()

  const org = useMemo(() => {
    return organizations?.find((org) => org.id === orgId)
  }, [organizations, orgId])

  return <>{org?.name}</>
}

export default memo(OrgCell)
